export default __webpack_public_path__ + "static/media/Wales-vs-Switzerland.3db34ec2.jpeg";